import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { PRODUCTS, demoStats, CATEGORIES } from "../../data/store";
import { PageTitle, Table, Badge, Btn } from "./ui";

export default function Stock() {
  const [levels, setLevels] = useState(() => Object.fromEntries(PRODUCTS.map((p) => [p.id, demoStats(p).stockLevel])));
  const [lowOnly, setLowOnly] = useState(false);
  const shown = PRODUCTS.filter((p) => !lowOnly || levels[p.id] < 10);
  const setLvl = (id, v) => setLevels((prev) => ({ ...prev, [id]: Math.max(0, Number(v) || 0) }));

  return (
    <div data-testid="admin-stock">
      <PageTitle right={
        <div className="flex gap-2 items-center">
          <label className="flex items-center gap-2 text-sm font-semibold"><input type="checkbox" checked={lowOnly} onChange={(e) => setLowOnly(e.target.checked)} data-testid="stock-low-filter" className="accent-[#D0121A]" /> Tikai zemi krājumi (&lt;10)</label>
          <Btn onClick={() => toast.success("Krājumi saglabāti (DEMO)", { description: "Izmaiņas nosūtītas noliktavas sistēmai." })} data-testid="stock-save" variant="red" className="flex items-center gap-1"><RefreshCw size={12} /> Saglabāt izmaiņas</Btn>
        </div>
      }>Krājumu pārvaldība</PageTitle>
      <Table head={["SKU", "Prece", "Kategorija", "Iepakojumā", "Krājums (gab.)", "Statuss"]} minWidth="760px">
        {shown.map((p) => {
          const lvl = levels[p.id];
          return (
            <tr key={p.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`stock-row-${p.id}`}>
              <td className="p-3 text-[#6B6B6B]">{p.sku}</td>
              <td className="font-semibold max-w-[260px] truncate">{p.name}</td>
              <td className="text-[#6B6B6B]">{CATEGORIES.find((c) => c.slug === p.category)?.name.split(" ")[0]}</td>
              <td>{p.packQty} gab.</td>
              <td>
                <input type="number" value={lvl} onChange={(e) => setLvl(p.id, e.target.value)} data-testid={`stock-input-${p.id}`}
                  className="w-24 h-8 px-2 border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
              </td>
              <td className="p-3"><Badge color={lvl === 0 ? "red" : lvl < 10 ? "amber" : "green"}>{lvl === 0 ? "Nav noliktavā" : lvl < 10 ? "Zems krājums" : "Pietiekams"}</Badge></td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}
